import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      brand: 'Parking SaaS',
      common: {
        checking: 'Comprobando…',
        activeOn: 'Activa',
        activeOff: 'Inactiva',
        loginFailed: 'No se pudo completar el acceso',
        save: 'Guardar',
        cancel: 'Cancelar',
        delete: 'Eliminar',
        actions: 'Acciones',
      },
      nav: {
        dashboard: 'Panel',
        users: 'Usuarios',
        parkings: 'Parkings',
        customers: 'Clientes',
        vehicles: 'Vehículos',
        sessions: 'Sesiones',
        tariffs: 'Tarifas',
        invoices: 'Facturas',
        reservations: 'Reservas',
        incidents: 'Incidencias',
        maintenance: 'Mantenimiento',
        employees: 'Empleados',
        barriers: 'Barreras',
        alpr: 'ALPR',
        matriculas: 'Matrículas',
        vigilancia: 'Vigilancia',
        reports: 'Informes',
        settings: 'Configuración',
        login: 'Acceso',
        logout: 'Salir',
      },
      enums: {
        vehicleType: {
          CAR: 'Coche',
          MOTORCYCLE: 'Moto',
          VAN: 'Furgoneta',
          BUS: 'Autobús',
          TRUCK: 'Camión',
          OTHER: 'Otro',
        },
        spotType: {
          STANDARD: 'Estándar',
          PMR: 'PMR',
          EV: 'Eléctrico',
          MOTORCYCLE: 'Moto',
          BUS: 'Autobús',
          TRUCK: 'Camión',
          VIP: 'VIP',
          SUBSCRIBER: 'Abonado',
        },
        spotStatus: {
          AVAILABLE: 'Libre',
          OCCUPIED: 'Ocupada',
          RESERVED: 'Reservada',
          OUT_OF_SERVICE: 'Fuera de servicio',
        },
        sessionStatus: {
          OPEN: 'Abierta',
          CLOSED: 'Cerrada',
          CANCELLED: 'Anulada',
          DISPUTED: 'En disputa',
        },
        subscriptionPlan: {
          MONTHLY: 'Mensual',
          QUARTERLY: 'Trimestral',
          YEARLY: 'Anual',
          COMPANY: 'Empresa',
          EMPLOYEE: 'Empleado',
          RESIDENT: 'Residente',
        },
        subscriptionStatus: {
          ACTIVE: 'Activo',
          PAST_DUE: 'Impago',
          CANCELLED: 'Cancelado',
          EXPIRED: 'Caducado',
        },
        tenantStatus: {
          ACTIVE: 'Activo',
          SUSPENDED: 'Suspendido',
          PENDING: 'Pendiente',
        },
        verifactuStatus: {
          DISABLED: 'Desactivado',
          DRAFT: 'Borrador',
          READY: 'Listo',
          ERROR: 'Error',
        },
        tariffKind: {
          MINUTE: 'Por minuto',
          HOUR: 'Por hora',
          DAILY: 'Diaria',
          NIGHT: 'Nocturna',
          WEEKEND: 'Fin de semana',
          HOLIDAY: 'Festivo',
          DYNAMIC: 'Dinámica',
        },
        paymentMethod: {
          CASH: 'Efectivo',
          CARD: 'Tarjeta',
          STRIPE: 'Stripe',
          PAYPAL: 'PayPal',
          BIZUM: 'Bizum',
          APPLE_PAY: 'Apple Pay',
          GOOGLE_PAY: 'Google Pay',
          TRANSFER: 'Transferencia',
        },
        invoiceStatus: {
          DRAFT: 'Borrador',
          ISSUED: 'Emitida',
          PAID: 'Pagada',
          VOID: 'Anulada',
          RECTIFIED: 'Rectificada',
        },
        reservationStatus: {
          PENDING: 'Pendiente',
          CONFIRMED: 'Confirmada',
          CHECKED_IN: 'Check-in',
          CANCELLED: 'Cancelada',
          NO_SHOW: 'No presentado',
          COMPLETED: 'Completada',
        },
        incidentType: {
          BROKEN_VEHICLE: 'Vehículo averiado',
          BLOCKED_SPOT: 'Plaza bloqueada',
          BARRIER_FAULT: 'Fallo de barrera',
          CONFLICT: 'Conflicto',
          LOST_PROPERTY: 'Objeto perdido',
          DAMAGE: 'Daños',
          OTHER: 'Otro',
        },
        incidentStatus: {
          OPEN: 'Abierta',
          IN_PROGRESS: 'En curso',
          RESOLVED: 'Resuelta',
          CLOSED: 'Cerrada',
        },
        maintenanceStatus: {
          SCHEDULED: 'Programada',
          IN_PROGRESS: 'En curso',
          DONE: 'Hecha',
          CANCELLED: 'Cancelada',
        },
        barrierState: {
          OPEN: 'Abierta',
          CLOSED: 'Cerrada',
          UNKNOWN: 'Desconocido',
          ERROR: 'Error',
        },
        barrierMode: {
          AUTOMATIC: 'Automático',
          MANUAL: 'Manual',
        },
        sensorTarget: {
          SPOT: 'Plaza',
          BARRIER: 'Barrera',
        },
        userStatus: {
          ACTIVE: 'Activo',
          INVITED: 'Invitado',
          SUSPENDED: 'Suspendido',
          DISABLED: 'Deshabilitado',
        },
      },
      login: {
        title: 'Acceso operativo',
        subtitle: 'Tenant: demo · Email: admin@demo.parking · Password: Admin123!',
        cta: 'Entrar',
        tenant: 'Tenant (slug)',
        email: 'Email',
        password: 'Contraseña',
        totp: 'Código 2FA',
        totpOptional: 'Opcional si 2FA no está activo',
        totpHint: 'Introduce el código de tu autenticador',
      },
      dashboard: {
        title: 'Centro de operaciones',
        subtitle: 'Vista global de ocupación, facturación, reservas e incidencias',
        health: 'Estado del API',
        phase: 'Roadmap completo',
        liveOn: 'En vivo',
        liveOff: 'Sin realtime',
        viewAll: 'Ver todo',
        noCharts: 'No tienes permisos de informes, reservas o facturación para ver gráficas.',
        cards: {
          spots: 'Ocupadas / total',
          vehicles: 'Sesiones abiertas',
          revenue: 'Cobrado (30 días)',
          occupancy: 'Ocupación',
          available: 'Disponibles',
          reservations: 'Reservas activas',
          reservationsHint: 'Pendientes / confirmadas',
          spotsHint: 'Plazas del tenant',
          sessionsHint: 'Sesiones activas',
          revenueHint: '{{count}} facturas en el periodo',
          invoiceStats: '{{paid}} cobradas · {{issued}} emitidas',
          collected: 'Cobrado',
          invoiced: 'Facturado',
        },
        charts: {
          occupancyTitle: 'Ocupación de plazas',
          reservationsTitle: 'Estado de reservas',
          invoicesTitle: 'Facturas por estado',
          revenueTitle: 'Facturación (7 días)',
          occupied: 'Ocupadas',
          available: 'Libres',
          other: 'Otras',
          billing: 'Importe',
          invoices: 'Facturas',
          empty: 'Sin datos',
        },
        lists: {
          openSessions: 'Sesiones abiertas',
          recentInvoices: 'Facturas recientes',
          reservations: 'Próximas reservas',
          incidents: 'Incidencias abiertas',
          parkings: 'Parkings',
          empty: 'Sin registros',
          emptyIncidents: 'Ninguna incidencia abierta',
          lastIncident: 'Última',
        },
        live: {
          title: 'Actividad en vivo',
          connected: 'Conectado al hub en tiempo real del tenant',
          waiting: 'Esperando conexión websocket…',
          openIncidents: '{{count}} incidencias abiertas',
        },
        placeholder: 'Dashboard con métricas y Socket.IO.',
        signedInAs: 'Sesión',
      },
      users: {
        title: 'Usuarios',
        subtitle: 'Gestión de usuarios del tenant actual',
        email: 'Email',
        name: 'Nombre',
        status: 'Estado',
        roles: 'Roles',
        forbidden: 'No tienes permiso users:read',
      },
      parkings: {
        title: 'Parkings',
        subtitle: 'CRUD de estructura, plazas y coordenadas en plano',
        code: 'Código',
        name: 'Nombre',
        address: 'Dirección',
        city: 'Ciudad',
        available: 'Libres',
        occupied: 'Ocupadas',
        occupancy: 'Ocupación',
        spots: 'Plazas',
        spotCode: 'Plaza',
        type: 'Tipo',
        status: 'Estado',
        zone: 'Zona',
        openSessions: 'Sesiones abiertas',
        plate: 'Matrícula',
        entryAt: 'Entrada',
        forbidden: 'No tienes permiso parkings:read',
        select: 'Parking activo',
        createParking: 'Nuevo parking',
        createSpot: 'Nueva plaza',
        editParking: 'Editar parking',
        editSpot: 'Editar plaza',
        floorPlan: 'Plano de plazas',
        floorPlanHint:
          'Arrastra el icono del vehículo para moverlo. Usa los controles para redimensionar y rotar. Clic vacío sitúa una plaza sin coordenadas. Si hay imagen de plano, sustituye la cuadrícula.',
        floorPlanImage: 'Imagen del plano',
        floorPlanImageHint: 'PNG, JPG o WEBP (máx. 6MB). Se usará como fondo del plano de plazas.',
        floorPlanRemove: 'Quitar imagen',
        floorPlanInvalid: 'Archivo de imagen no válido',
        floorPlanTooLarge: 'La imagen supera 6MB',
        floorPlanCanvasEmpty:
          'Sube el plano del parking al crear/editar para usarlo como fondo',
        spotLabelColor: 'Color del nombre',
        spotLabelColorHint: 'Color del texto bajo el icono del vehículo en el plano',
        save: 'Guardar',
        cancel: 'Cancelar',
        confirmDeleteParking: '¿Eliminar este parking y su estructura?',
        confirmDeleteSpot: '¿Eliminar esta plaza?',
      },
      customers: {
        title: 'Clientes',
        subtitle: 'Clientes, vehículos vinculados y abonos',
        code: 'Código',
        name: 'Nombre',
        firstName: 'Nombre',
        lastName: 'Apellidos',
        email: 'Email',
        phone: 'Teléfono',
        taxId: 'NIF/CIF',
        company: 'Empresa',
        vehicles: 'Vehículos',
        subs: 'Abonos activos',
        linkedVehicles: 'Vehículos del cliente',
        subscriptions: 'Abonos',
        plan: 'Plan',
        status: 'Estado',
        price: 'Precio',
        priceCents: 'Precio (céntimos)',
        startsAt: 'Inicio',
        endsAt: 'Fin',
        create: 'Nuevo cliente',
        createSub: 'Nuevo abono',
        edit: 'Editar cliente',
        editSub: 'Editar abono',
        linkVehicle: 'Vincular vehículo',
        linkHint: 'Crea vehículos en la sección Vehículos y vincúlalos aquí.',
        save: 'Guardar',
        cancel: 'Cancelar',
        confirmDelete: '¿Eliminar este cliente?',
        confirmDeleteSub: '¿Eliminar este abono?',
        forbidden: 'No tienes permiso customers:read',
      },
      vehicles: {
        title: 'Vehículos',
        subtitle: 'Flota y matrículas del tenant',
        plate: 'Matrícula',
        brand: 'Marca',
        model: 'Modelo',
        color: 'Color',
        type: 'Tipo',
        customers: 'Clientes',
        linkCustomer: 'Vincular a cliente',
        create: 'Nuevo vehículo',
        edit: 'Editar vehículo',
        save: 'Guardar',
        cancel: 'Cancelar',
        confirmDelete: '¿Eliminar este vehículo?',
        forbidden: 'No tienes permiso vehicles:read',
      },
      sessions: {
        title: 'Sesiones',
        subtitle: 'Entradas, salidas y cobro con tarifa',
        plate: 'Matrícula',
        parking: 'Parking',
        spot: 'Plaza',
        status: 'Estado',
        entryAt: 'Entrada',
        duration: 'Duración',
        amount: 'Importe',
        payment: 'Pago',
        open: 'Nueva entrada',
        close: 'Salida',
        cancel: 'Anular',
        cancelBtn: 'Cancelar',
        save: 'Registrar',
        confirmClose: 'Cobrar y cerrar',
        confirmCancel: '¿Anular esta sesión abierta?',
        filter: 'Filtro',
        filterOpen: 'Abiertas',
        filterClosed: 'Cerradas',
        filterAll: 'Todas',
        subscriberFree: 'Abonado activo — importe 0 €',
        quote: '{{minutes}} min · {{amount}} € ({{tariff}})',
        invoiceIssued: 'Factura emitida: {{number}}',
        forbidden: 'No tienes permiso sessions:read',
      },
      invoices: {
        title: 'Facturas',
        subtitle: 'Emisión, IVA y marcado Verifactu-ready',
        number: 'Número',
        plate: 'Matrícula',
        customer: 'Cliente',
        status: 'Estado',
        net: 'Base',
        vat: 'IVA',
        total: 'Total',
        verifactu: 'Verifactu',
        issuedAt: 'Emisión',
        filter: 'Filtro',
        filterAll: 'Todas',
        void: 'Anular',
        confirmVoid: '¿Anular esta factura?',
        seriesHint: 'Series: {{series}}',
        statusPaid: 'Pagada',
        statusIssued: 'Emitida',
        statusVoid: 'Anulada',
        forbidden: 'No tienes permiso billing:read',
      },
      tariffs: {
        title: 'Tarifas',
        subtitle: 'Reglas de precio por franjas de minutos',
        code: 'Código',
        name: 'Nombre',
        kind: 'Tipo',
        priority: 'Prioridad',
        active: 'Activa',
        rules: 'Reglas',
        parking: 'Parking',
        global: 'Global (todos)',
        firstHour: '1ª hora (céntimos)',
        extraHour: 'Hora extra (céntimos)',
        maxCharge: 'Tope (céntimos)',
        centsHint: 'Ej. 250 = 2,50 €',
        create: 'Nueva tarifa',
        edit: 'Editar tarifa',
        save: 'Guardar',
        cancel: 'Cancelar',
        confirmDelete: '¿Eliminar esta tarifa?',
        forbidden: 'No tienes permiso tariffs:read',
      },

      reservations: {
        title: 'Reservas',
        subtitle: 'Gestiona reservas de plaza',
        forbidden: 'No tienes permiso reservations:read',
        create: 'Nueva reserva',
        status: 'Estado',
        starts: 'Inicio',
        ends: 'Fin',
        parking: 'Parking',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        checkIn: 'Check-in',
      },
      incidents: {
        title: 'Incidencias',
        subtitle: 'Seguimiento operativo',
        forbidden: 'No tienes permiso incidents:read',
        create: 'Nueva incidencia',
        type: 'Tipo',
        titleCol: 'Título',
        status: 'Estado',
        created: 'Creada',
        description: 'Descripción',
        resolve: 'Resolver',
      },
      maintenance: {
        title: 'Mantenimiento',
        subtitle: 'Tareas programadas',
        forbidden: 'No tienes permiso maintenance:read',
        create: 'Nueva tarea',
        titleCol: 'Título',
        assignee: 'Asignado',
        status: 'Estado',
        scheduled: 'Programada',
        complete: 'Completar',
      },
      employees: {
        title: 'Empleados',
        subtitle: 'Personal del parking',
        forbidden: 'Sin permiso de empleados',
        create: 'Nuevo empleado',
        code: 'Código',
        name: 'Nombre',
        firstName: 'Nombre',
        lastName: 'Apellidos',
        role: 'Puesto',
        active: 'Activo',
        hiredAt: 'Alta',
      },
      barriers: {
        title: 'Barreras y sensores',
        subtitle: 'Control de accesos y ocupación',
        forbidden: 'No tienes permiso parkings:read',
        create: 'Nueva barrera',
        edit: 'Editar barrera',
        confirmDelete: '¿Eliminar esta barrera?',
        createSensor: 'Nuevo sensor',
        editSensor: 'Editar sensor',
        confirmDeleteSensor: '¿Eliminar este sensor?',
        code: 'Código',
        name: 'Nombre',
        mode: 'Modo',
        state: 'Estado',
        open: 'Abrir',
        close: 'Cerrar',
        refresh: 'Estado',
        sensors: 'Sensores',
        occupied: 'Ocupado',
        battery: 'Batería',
        lastSeen: 'Última señal',
        parking: 'Parking',
        spot: 'Plaza',
        barrier: 'Barrera',
        externalId: 'ID externo',
        endpoint: 'API endpoint',
        target: 'Actúa sobre',
        targetRef: 'Destino',
        targetSpot: 'Plaza',
        targetBarrier: 'Barrera',
        targetHelp: 'Plaza: actualiza la ocupación en el plano. Barrera: abre/cierra al detectar vehículo.',
        spotHelp: 'Si el sensor detecta un vehículo, el icono de la plaza se muestra ocupado en el plano.',
        sensorEndpoint: 'Endpoint de barrera (opcional)',
        sensorEndpointHelp: 'Si se deja vacío, se usa el API endpoint configurado en la barrera.',
      },
      reports: {
        title: 'Informes e IA',
        subtitle: 'Ocupación, ingresos y previsiones',
        forbidden: 'No tienes permiso reports:read',
        occupancy: 'Ocupación',
        revenue: 'Ingresos',
        openSessions: 'Sesiones abiertas',
        invoices: 'facturas',
        paid: 'cobrado',
        exported: 'Exportado',
        ai: 'Insights IA',
        generateAi: 'Generar previsión',
        noInsights: 'Sin insights aún',
      },
      alpr: {
        title: 'ALPR',
        subtitle: 'Lectura de matrículas',
        forbidden: 'Sin permiso ALPR',
        provider: 'Proveedor',
        imageUrl: 'URL imagen',
        recognize: 'Reconocer',
        cameras: 'Cámaras',
        code: 'Código',
        name: 'Nombre',
        reads: 'Lecturas',
        plate: 'Matrícula',
        confidence: 'Confianza',
        when: 'Cuándo',
      },
      matriculas: {
        title: 'Matrículas',
        subtitle: 'Prueba de reconocimiento con OpenAI Vision',
        forbidden: 'Sin permiso para matrículas',
        read: 'Leer matrícula',
        send: 'Enviar a OpenAI',
        recognizing: 'Reconociendo…',
        upload: 'Imagen de matrícula',
        needImage: 'Selecciona una imagen',
        invalidImage: 'Imagen no válida',
        imageTooLarge: 'La imagen supera 6 MB',
        openaiHint:
          'Se usa la API y el modelo configurados en Configuración → OpenAI. Debe estar activa y con API key.',
        dropTitle: 'Arrastra aquí la imagen de la matrícula',
        dropHint: 'o haz clic para seleccionarla (PNG, JPG, WEBP · máx. 6 MB)',
        dropReplace: 'Arrastra otra imagen o haz clic para cambiarla',
        clearImage: 'Quitar imagen',
        image: 'Imagen',
        plate: 'Matrícula',
        confidence: 'Confianza',
        model: 'Modelo',
        status: 'Estado',
        when: 'Cuándo',
        detail: 'Detalle',
        requestMeta: 'Datos enviados a OpenAI',
        openaiResponse: 'Respuesta de OpenAI',
      },
      vigilancia: {
        title: 'Vigilancia',
        subtitle: 'Cámaras web en directo',
        forbidden: 'No tienes permiso para ver vigilancia',
        empty: 'No hay cámaras web activas. Añádelas en Configuración → Cámaras web.',
        loading: 'Cargando cámaras…',
        expand: 'Pantalla completa',
        close: 'Cerrar',
      },
      settings: {
        title: 'Configuración',
        subtitle: 'Empresa, Verifactu, OpenAI, notificaciones, cámaras IP y vigilancia web',
        forbidden: 'No tienes permiso settings:read',
        saved: 'Configuración guardada',
        tabs: {
          company: 'Empresa',
          verifactu: 'Verifactu',
          openai: 'OpenAI',
          push: 'Notificaciones',
          cameras: 'Cámaras IP',
          surveillance: 'Cámaras web',
        },
        cameras: {
          hint: 'Configura las cámaras IP del parking. Más adelante podrás visualizar sus streams en una página dedicada.',
          create: 'Nueva cámara',
          edit: 'Editar cámara',
          code: 'Código',
          name: 'Nombre',
          parking: 'Parking',
          selectParking: 'Selecciona un parking',
          host: 'IP / host',
          port: 'Puerto',
          username: 'Usuario',
          password: 'Contraseña',
          passwordKeep: 'Dejar en blanco para no cambiar',
          passwordPlaceholder: 'Opcional',
          protocol: 'Protocolo',
          streamUrl: 'URL de stream',
          streamUrlHint: 'RTSP/HTTP completa, o ruta del stream si usas host/puerto',
          isActive: 'Activa',
          alprEnabled: 'ALPR habilitado',
          status: 'Estado',
          confirmDelete: '¿Eliminar esta cámara?',
        },
        surveillance: {
          hint: 'URLs embebibles (p. ej. Ibericam) que se muestran en la página Vigilancia.',
          create: 'Nueva cámara web',
          edit: 'Editar cámara web',
          code: 'Código',
          location: 'Ubicación',
          url: 'URL',
          urlHint: 'Dirección del reproductor web (iframe), p. ej. Ibericam u otro proveedor.',
          isActive: 'Activa',
          status: 'Estado',
          confirmDelete: '¿Eliminar esta cámara web?',
        },
        company: {
          legalName: 'Razón social',
          tradeName: 'Nombre comercial',
          taxId: 'NIF/CIF',
          address: 'Dirección',
          city: 'Ciudad',
          postalCode: 'Código postal',
          province: 'Provincia',
          country: 'País (ISO)',
          phone: 'Teléfono',
          email: 'Email fiscal',
          website: 'Web',
          timezone: 'Zona horaria',
          locale: 'Idioma',
          currency: 'Moneda',
          vat: 'IVA por defecto (%)',
          footer: 'Pie de factura',
        },
        verifactu: {
          enabled: 'Verifactu activo',
          status: 'Estado',
          environment: 'Entorno',
          nif: 'NIF emisor',
          razon: 'Nombre / razón social',
          softwareNif: 'NIF software',
          softwareName: 'Nombre software',
          softwareId: 'ID software',
          softwareVersion: 'Versión software',
          apiUrl: 'URL AEAT',
          certificate: 'Certificado PEM',
          certificateHint: 'Pega el certificado (se almacena cifrado). Déjalo vacío para no cambiarlo.',
          passphrase: 'Passphrase certificado',
          validate: 'Validar configuración',
          validated: 'Verifactu validado y listo',
          hasCert: 'Certificado cargado',
          noCert: 'Sin certificado',
        },
        openai: {
          enabled: 'OpenAI activo',
          apiKey: 'API key',
          apiKeyPlaceholder: 'sk-…',
          apiKeyKeep: '•••••••• (dejar vacío para no cambiar)',
          apiKeyHint: 'Se almacena cifrada. Déjala vacía para conservar la actual.',
          hasKey: 'API key configurada',
          noKey: 'Sin API key',
          organizationId: 'Organization ID',
          projectId: 'Project ID',
          baseUrl: 'Base URL',
          defaultModel: 'Modelo por defecto',
          temperature: 'Temperatura',
          maxTokens: 'Max tokens',
          models: {
            'gpt-4o-mini': 'gpt-4o-mini (ideal para reconocer imágenes)',
            'gpt-4o': 'gpt-4o (ideal para visión avanzada y multimodal)',
            'gpt-4.1-mini': 'gpt-4.1-mini (ideal para texto rápido y económico)',
            'gpt-4.1': 'gpt-4.1 (ideal para textos largos y precisión)',
            'o4-mini': 'o4-mini (ideal para razonamiento complejo)',
            'o3-mini': 'o3-mini (ideal para lógica y planificación)',
            'gpt-4o-mini-tts': 'gpt-4o-mini-tts (ideal para síntesis de voz)',
            'text-embedding-3-small': 'text-embedding-3-small (ideal para búsquedas semánticas)',
            'whisper-1': 'whisper-1 (ideal para transcribir audio)',
          },
        },
        push: {
          enabled: 'Push / webhooks activos',
          notifyOpen: 'Entradas',
          notifyClose: 'Salidas',
          notifyInvoice: 'Facturas',
          notifyPayment: 'Pagos',
          notifyIncident: 'Incidencias',
          webhookUrl: 'Webhook URL',
          webhookSecret: 'Webhook secret',
          subscribe: 'Activar en este dispositivo',
          test: 'Enviar prueba',
          devices: 'Dispositivos',
          logs: 'Historial de envíos',
          label: 'Dispositivo',
          created: 'Creado',
          channel: 'Canal',
          titleCol: 'Mensaje',
          status: 'Estado',
          noVapid: 'VAPID no configurado en plataforma',
          unsupported: 'Este navegador no soporta Web Push',
          denied: 'Permiso de notificaciones denegado',
          subscribeFailed: 'No se pudo suscribir al push',
          subscribed: 'Dispositivo registrado',
          testResult: 'Prueba enviada: {{sent}} ok, {{failed}} fallos',
        },
      },
      platform: {
        brand: 'Parking Platform',
        login: {
          subtitle: 'Acceso super-admin de la plataforma SaaS',
          email: 'Email',
          password: 'Contraseña',
          submit: 'Entrar',
          tenantLogin: 'Acceso tenant',
        },
        nav: {
          dashboard: 'Panel',
          tenants: 'Tenants',
          settings: 'Plataforma',
        },
        dashboard: {
          title: 'Panel de plataforma',
          subtitle: 'Vista global de todos los tenants',
          tenants: 'Tenants',
          active: 'Activos',
          users: 'Usuarios',
          openSessions: 'Sesiones abiertas',
          recent: 'Tenants recientes',
        },
        tenants: {
          title: 'Tenants',
          subtitle: 'Alta, suspensión y primer administrador',
          create: 'Nuevo tenant',
          edit: 'Editar tenant',
          slug: 'Slug',
          slugHint: 'minúsculas-kebab-case',
          name: 'Nombre',
          status: 'Estado',
          users: 'Usuarios',
          parkings: 'Parkings',
          sessions: 'Sesiones',
          adminSection: 'Administrador inicial (opcional)',
          adminEmail: 'Email admin',
          adminPassword: 'Password admin',
          adminFirstName: 'Nombre',
          adminLastName: 'Apellidos',
        },
        settings: {
          title: 'Ajustes de plataforma',
          subtitle: 'VAPID Web Push y super-admins',
          push: 'Web Push (VAPID)',
          supportEmail: 'Email soporte',
          vapidSubject: 'VAPID subject',
          vapidSubjectHint: 'mailto:…',
          vapidPublic: 'Clave pública VAPID',
          regenVapid: 'Regenerar VAPID',
          confirmRegen: '¿Regenerar claves VAPID? Los dispositivos deberán volver a suscribirse.',
          vapidRegenerated: 'Claves VAPID regeneradas',
          saved: 'Ajustes guardados',
          admins: 'Super-admins',
          createAdmin: 'Nuevo super-admin',
          adminName: 'Nombre',
        },
      },
    },
  },
  en: {
    translation: {
      brand: 'Parking SaaS',
      common: {
        checking: 'Checking…',
        activeOn: 'Active',
        activeOff: 'Inactive',
        loginFailed: 'Could not complete sign-in',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        actions: 'Actions',
      },
      nav: {
        dashboard: 'Dashboard',
        users: 'Users',
        parkings: 'Parkings',
        customers: 'Customers',
        vehicles: 'Vehicles',
        sessions: 'Sessions',
        tariffs: 'Tariffs',
        invoices: 'Invoices',
        reservations: 'Reservations',
        incidents: 'Incidents',
        maintenance: 'Maintenance',
        employees: 'Employees',
        barriers: 'Barriers',
        alpr: 'ALPR',
        matriculas: 'License plates',
        vigilancia: 'Surveillance',
        reports: 'Reports',
        settings: 'Settings',
        login: 'Sign in',
        logout: 'Sign out',
      },
      enums: {
        vehicleType: {
          CAR: 'Car',
          MOTORCYCLE: 'Motorcycle',
          VAN: 'Van',
          BUS: 'Bus',
          TRUCK: 'Truck',
          OTHER: 'Other',
        },
        spotType: {
          STANDARD: 'Standard',
          PMR: 'Accessible',
          EV: 'EV',
          MOTORCYCLE: 'Motorcycle',
          BUS: 'Bus',
          TRUCK: 'Truck',
          VIP: 'VIP',
          SUBSCRIBER: 'Subscriber',
        },
        spotStatus: {
          AVAILABLE: 'Available',
          OCCUPIED: 'Occupied',
          RESERVED: 'Reserved',
          OUT_OF_SERVICE: 'Out of service',
        },
        sessionStatus: {
          OPEN: 'Open',
          CLOSED: 'Closed',
          CANCELLED: 'Cancelled',
          DISPUTED: 'Disputed',
        },
        subscriptionPlan: {
          MONTHLY: 'Monthly',
          QUARTERLY: 'Quarterly',
          YEARLY: 'Yearly',
          COMPANY: 'Company',
          EMPLOYEE: 'Employee',
          RESIDENT: 'Resident',
        },
        subscriptionStatus: {
          ACTIVE: 'Active',
          PAST_DUE: 'Past due',
          CANCELLED: 'Cancelled',
          EXPIRED: 'Expired',
        },
        tenantStatus: {
          ACTIVE: 'Active',
          SUSPENDED: 'Suspended',
          PENDING: 'Pending',
        },
        verifactuStatus: {
          DISABLED: 'Disabled',
          DRAFT: 'Draft',
          READY: 'Ready',
          ERROR: 'Error',
        },
        tariffKind: {
          MINUTE: 'Per minute',
          HOUR: 'Hourly',
          DAILY: 'Daily',
          NIGHT: 'Night',
          WEEKEND: 'Weekend',
          HOLIDAY: 'Holiday',
          DYNAMIC: 'Dynamic',
        },
        paymentMethod: {
          CASH: 'Cash',
          CARD: 'Card',
          STRIPE: 'Stripe',
          PAYPAL: 'PayPal',
          BIZUM: 'Bizum',
          APPLE_PAY: 'Apple Pay',
          GOOGLE_PAY: 'Google Pay',
          TRANSFER: 'Transfer',
        },
        invoiceStatus: {
          DRAFT: 'Draft',
          ISSUED: 'Issued',
          PAID: 'Paid',
          VOID: 'Void',
          RECTIFIED: 'Rectified',
        },
        reservationStatus: {
          PENDING: 'Pending',
          CONFIRMED: 'Confirmed',
          CHECKED_IN: 'Checked in',
          CANCELLED: 'Cancelled',
          NO_SHOW: 'No-show',
          COMPLETED: 'Completed',
        },
        incidentType: {
          BROKEN_VEHICLE: 'Broken vehicle',
          BLOCKED_SPOT: 'Blocked spot',
          BARRIER_FAULT: 'Barrier fault',
          CONFLICT: 'Conflict',
          LOST_PROPERTY: 'Lost property',
          DAMAGE: 'Damage',
          OTHER: 'Other',
        },
        incidentStatus: {
          OPEN: 'Open',
          IN_PROGRESS: 'In progress',
          RESOLVED: 'Resolved',
          CLOSED: 'Closed',
        },
        maintenanceStatus: {
          SCHEDULED: 'Scheduled',
          IN_PROGRESS: 'In progress',
          DONE: 'Done',
          CANCELLED: 'Cancelled',
        },
        barrierState: {
          OPEN: 'Open',
          CLOSED: 'Closed',
          UNKNOWN: 'Unknown',
          ERROR: 'Error',
        },
        barrierMode: {
          AUTOMATIC: 'Automatic',
          MANUAL: 'Manual',
        },
        sensorTarget: {
          SPOT: 'Spot',
          BARRIER: 'Barrier',
        },
        userStatus: {
          ACTIVE: 'Active',
          INVITED: 'Invited',
          SUSPENDED: 'Suspended',
          DISABLED: 'Disabled',
        },
      },
      login: {
        title: 'Operations access',
        subtitle: 'Tenant: demo · Email: admin@demo.parking · Password: Admin123!',
        cta: 'Sign in',
        tenant: 'Tenant (slug)',
        email: 'Email',
        password: 'Password',
        totp: '2FA code',
        totpOptional: 'Optional if 2FA is off',
        totpHint: 'Enter your authenticator code',
      },
      dashboard: {
        title: 'Operations center',
        subtitle: 'Global view of occupancy, billing, reservations and incidents',
        health: 'API status',
        phase: 'Full roadmap',
        liveOn: 'Live',
        liveOff: 'Offline',
        viewAll: 'View all',
        noCharts: 'Missing permissions for reports, reservations or billing charts.',
        cards: {
          spots: 'Occupied / total',
          vehicles: 'Open sessions',
          revenue: 'Collected (30 days)',
          occupancy: 'Occupancy',
          available: 'Available',
          reservations: 'Active reservations',
          reservationsHint: 'Pending / confirmed',
          spotsHint: 'Tenant spots',
          sessionsHint: 'Active sessions',
          revenueHint: '{{count}} invoices in period',
          invoiceStats: '{{paid}} paid · {{issued}} issued',
          collected: 'Collected',
          invoiced: 'Invoiced',
        },
        charts: {
          occupancyTitle: 'Spot occupancy',
          reservationsTitle: 'Reservation status',
          invoicesTitle: 'Invoices by status',
          revenueTitle: 'Billing (7 days)',
          occupied: 'Occupied',
          available: 'Free',
          other: 'Other',
          billing: 'Amount',
          invoices: 'Invoices',
          empty: 'No data',
        },
        lists: {
          openSessions: 'Open sessions',
          recentInvoices: 'Recent invoices',
          reservations: 'Upcoming reservations',
          incidents: 'Open incidents',
          parkings: 'Parkings',
          empty: 'No records',
          emptyIncidents: 'No open incidents',
          lastIncident: 'Latest',
        },
        live: {
          title: 'Live activity',
          connected: 'Connected to the tenant realtime hub',
          waiting: 'Waiting for websocket…',
          openIncidents: '{{count}} open incidents',
        },
        placeholder: 'Dashboard with metrics and Socket.IO.',
        signedInAs: 'Signed in',
      },
      users: {
        title: 'Users',
        subtitle: 'Manage users for the current tenant',
        email: 'Email',
        name: 'Name',
        status: 'Status',
        roles: 'Roles',
        forbidden: 'Missing permission users:read',
      },
      parkings: {
        title: 'Parkings',
        subtitle: 'Structure CRUD, spots and floor-plan coordinates',
        code: 'Code',
        name: 'Name',
        address: 'Address',
        city: 'City',
        available: 'Free',
        occupied: 'Occupied',
        occupancy: 'Occupancy',
        spots: 'Spots',
        spotCode: 'Spot',
        type: 'Type',
        status: 'Status',
        zone: 'Zone',
        openSessions: 'Open sessions',
        plate: 'Plate',
        entryAt: 'Entry',
        forbidden: 'Missing permission parkings:read',
        select: 'Active parking',
        createParking: 'New parking',
        createSpot: 'New spot',
        editParking: 'Edit parking',
        editSpot: 'Edit spot',
        floorPlan: 'Spot floor plan',
        floorPlanHint:
          'Drag the vehicle icon to move it. Use handles to resize and rotate. Empty click places a spot without coordinates. A floor-plan image replaces the grid background.',
        floorPlanImage: 'Floor plan image',
        floorPlanImageHint: 'PNG, JPG or WEBP (max 6MB). Used as the spots map background.',
        floorPlanRemove: 'Remove image',
        floorPlanInvalid: 'Invalid image file',
        floorPlanTooLarge: 'Image exceeds 6MB',
        floorPlanCanvasEmpty:
          'Upload a floor-plan image when creating/editing the parking to use it as background',
        spotLabelColor: 'Label color',
        spotLabelColorHint: 'Text color under the vehicle icon on the floor plan',
        save: 'Save',
        cancel: 'Cancel',
        confirmDeleteParking: 'Delete this parking and its structure?',
        confirmDeleteSpot: 'Delete this spot?',
      },
      customers: {
        title: 'Customers',
        subtitle: 'Customers, linked vehicles and subscriptions',
        code: 'Code',
        name: 'Name',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email',
        phone: 'Phone',
        taxId: 'Tax ID',
        company: 'Company',
        vehicles: 'Vehicles',
        subs: 'Active subs',
        linkedVehicles: 'Customer vehicles',
        subscriptions: 'Subscriptions',
        plan: 'Plan',
        status: 'Status',
        price: 'Price',
        priceCents: 'Price (cents)',
        startsAt: 'Starts',
        endsAt: 'Ends',
        create: 'New customer',
        createSub: 'New subscription',
        edit: 'Edit customer',
        editSub: 'Edit subscription',
        linkVehicle: 'Link vehicle',
        linkHint: 'Create vehicles under Vehicles and link them here.',
        save: 'Save',
        cancel: 'Cancel',
        confirmDelete: 'Delete this customer?',
        confirmDeleteSub: 'Delete this subscription?',
        forbidden: 'Missing permission customers:read',
      },
      vehicles: {
        title: 'Vehicles',
        subtitle: 'Fleet and plates for this tenant',
        plate: 'Plate',
        brand: 'Brand',
        model: 'Model',
        color: 'Color',
        type: 'Type',
        customers: 'Customers',
        linkCustomer: 'Link to customer',
        create: 'New vehicle',
        edit: 'Edit vehicle',
        save: 'Save',
        cancel: 'Cancel',
        confirmDelete: 'Delete this vehicle?',
        forbidden: 'Missing permission vehicles:read',
      },
      sessions: {
        title: 'Sessions',
        subtitle: 'Entry, exit and tariff charging',
        plate: 'Plate',
        parking: 'Parking',
        spot: 'Spot',
        status: 'Status',
        entryAt: 'Entry',
        duration: 'Duration',
        amount: 'Amount',
        payment: 'Payment',
        open: 'New entry',
        close: 'Exit',
        cancel: 'Void',
        cancelBtn: 'Cancel',
        save: 'Register',
        confirmClose: 'Charge and close',
        confirmCancel: 'Cancel this open session?',
        filter: 'Filter',
        filterOpen: 'Open',
        filterClosed: 'Closed',
        filterAll: 'All',
        subscriberFree: 'Active subscriber — amount 0 €',
        quote: '{{minutes}} min · {{amount}} € ({{tariff}})',
        invoiceIssued: 'Invoice issued: {{number}}',
        forbidden: 'Missing permission sessions:read',
      },
      invoices: {
        title: 'Invoices',
        subtitle: 'Issuing, VAT and Verifactu-ready flag',
        number: 'Number',
        plate: 'Plate',
        customer: 'Customer',
        status: 'Status',
        net: 'Net',
        vat: 'VAT',
        total: 'Total',
        verifactu: 'Verifactu',
        issuedAt: 'Issued',
        filter: 'Filter',
        filterAll: 'All',
        void: 'Void',
        confirmVoid: 'Void this invoice?',
        seriesHint: 'Series: {{series}}',
        statusPaid: 'Paid',
        statusIssued: 'Issued',
        statusVoid: 'Void',
        forbidden: 'Missing permission billing:read',
      },
      tariffs: {
        title: 'Tariffs',
        subtitle: 'Pricing rules by minute bands',
        code: 'Code',
        name: 'Name',
        kind: 'Kind',
        priority: 'Priority',
        active: 'Active',
        rules: 'Rules',
        parking: 'Parking',
        global: 'Global (all)',
        firstHour: '1st hour (cents)',
        extraHour: 'Extra hour (cents)',
        maxCharge: 'Cap (cents)',
        centsHint: 'E.g. 250 = 2.50 €',
        create: 'New tariff',
        edit: 'Edit tariff',
        save: 'Save',
        cancel: 'Cancel',
        confirmDelete: 'Delete this tariff?',
        forbidden: 'Missing permission tariffs:read',
      },

      reservations: {
        title: 'Reservations',
        subtitle: 'Manage spot bookings',
        forbidden: 'Missing permission reservations:read',
        create: 'New reservation',
        status: 'Status',
        starts: 'Starts',
        ends: 'Ends',
        parking: 'Parking',
        confirm: 'Confirm',
        cancel: 'Cancel',
        checkIn: 'Check-in',
      },
      incidents: {
        title: 'Incidents',
        subtitle: 'Operational tracking',
        forbidden: 'Missing permission incidents:read',
        create: 'New incident',
        type: 'Type',
        titleCol: 'Title',
        status: 'Status',
        created: 'Created',
        description: 'Description',
        resolve: 'Resolve',
      },
      maintenance: {
        title: 'Maintenance',
        subtitle: 'Scheduled tasks',
        forbidden: 'Missing permission maintenance:read',
        create: 'New task',
        titleCol: 'Title',
        assignee: 'Assignee',
        status: 'Status',
        scheduled: 'Scheduled',
        complete: 'Complete',
      },
      employees: {
        title: 'Employees',
        subtitle: 'Parking staff',
        forbidden: 'Missing employees permission',
        create: 'New employee',
        code: 'Code',
        name: 'Name',
        firstName: 'First name',
        lastName: 'Last name',
        role: 'Role',
        active: 'Active',
        hiredAt: 'Hired',
      },
      barriers: {
        title: 'Barriers & sensors',
        subtitle: 'Access control and occupancy',
        forbidden: 'Missing permission parkings:read',
        create: 'New barrier',
        edit: 'Edit barrier',
        confirmDelete: 'Delete this barrier?',
        createSensor: 'New sensor',
        editSensor: 'Edit sensor',
        confirmDeleteSensor: 'Delete this sensor?',
        code: 'Code',
        name: 'Name',
        mode: 'Mode',
        state: 'State',
        open: 'Open',
        close: 'Close',
        refresh: 'Status',
        sensors: 'Sensors',
        occupied: 'Occupied',
        battery: 'Battery',
        lastSeen: 'Last seen',
        parking: 'Parking',
        spot: 'Spot',
        barrier: 'Barrier',
        externalId: 'External ID',
        endpoint: 'API endpoint',
        target: 'Acts on',
        targetRef: 'Target',
        targetSpot: 'Spot',
        targetBarrier: 'Barrier',
        targetHelp: 'Spot: updates occupancy on the floor plan. Barrier: opens/closes on vehicle detection.',
        spotHelp: 'When the sensor detects a vehicle, the spot icon is shown as occupied on the floor plan.',
        sensorEndpoint: 'Barrier endpoint (optional)',
        sensorEndpointHelp: 'If empty, the barrier API endpoint is used.',
      },
      reports: {
        title: 'Reports & AI',
        subtitle: 'Occupancy, revenue and forecasts',
        forbidden: 'Missing permission reports:read',
        occupancy: 'Occupancy',
        revenue: 'Revenue',
        openSessions: 'Open sessions',
        invoices: 'invoices',
        paid: 'collected',
        exported: 'Exported',
        ai: 'AI insights',
        generateAi: 'Generate forecast',
        noInsights: 'No insights yet',
      },
      alpr: {
        title: 'ALPR',
        subtitle: 'License plate recognition',
        forbidden: 'Missing ALPR permission',
        provider: 'Provider',
        imageUrl: 'Image URL',
        recognize: 'Recognize',
        cameras: 'Cameras',
        code: 'Code',
        name: 'Name',
        reads: 'Reads',
        plate: 'Plate',
        confidence: 'Confidence',
        when: 'When',
      },
      matriculas: {
        title: 'License plates',
        subtitle: 'OpenAI Vision recognition test',
        forbidden: 'Missing permission for license plates',
        read: 'Read plate',
        send: 'Send to OpenAI',
        recognizing: 'Recognizing…',
        upload: 'Plate image',
        needImage: 'Select an image',
        invalidImage: 'Invalid image',
        imageTooLarge: 'Image exceeds 6 MB',
        openaiHint:
          'Uses the API and model from Settings → OpenAI. It must be enabled with an API key.',
        dropTitle: 'Drop the plate image here',
        dropHint: 'or click to browse (PNG, JPG, WEBP · max 6 MB)',
        dropReplace: 'Drop another image or click to replace',
        clearImage: 'Remove image',
        image: 'Image',
        plate: 'Plate',
        confidence: 'Confidence',
        model: 'Model',
        status: 'Status',
        when: 'When',
        detail: 'Details',
        requestMeta: 'Data sent to OpenAI',
        openaiResponse: 'OpenAI response',
      },
      vigilancia: {
        title: 'Surveillance',
        subtitle: 'Live web cameras',
        forbidden: 'Missing permission to view surveillance',
        empty: 'No active web cameras. Add them in Settings → Web cameras.',
        loading: 'Loading cameras…',
        expand: 'Fullscreen',
        close: 'Close',
      },
      settings: {
        title: 'Settings',
        subtitle: 'Company, Verifactu, OpenAI, notifications, IP cameras and web surveillance',
        forbidden: 'Missing permission settings:read',
        saved: 'Settings saved',
        tabs: {
          company: 'Company',
          verifactu: 'Verifactu',
          openai: 'OpenAI',
          push: 'Notifications',
          cameras: 'IP cameras',
          surveillance: 'Web cameras',
        },
        cameras: {
          hint: 'Configure parking IP cameras. Streams will be viewable later on a dedicated page.',
          create: 'New camera',
          edit: 'Edit camera',
          code: 'Code',
          name: 'Name',
          parking: 'Parking',
          selectParking: 'Select a parking',
          host: 'IP / host',
          port: 'Port',
          username: 'Username',
          password: 'Password',
          passwordKeep: 'Leave blank to keep current',
          passwordPlaceholder: 'Optional',
          protocol: 'Protocol',
          streamUrl: 'Stream URL',
          streamUrlHint: 'Full RTSP/HTTP URL, or stream path if using host/port',
          isActive: 'Active',
          alprEnabled: 'ALPR enabled',
          status: 'Status',
          confirmDelete: 'Delete this camera?',
        },
        surveillance: {
          hint: 'Embeddable URLs (e.g. Ibericam) shown on the Surveillance page.',
          create: 'New web camera',
          edit: 'Edit web camera',
          code: 'Code',
          location: 'Location',
          url: 'URL',
          urlHint: 'Web player URL (iframe), e.g. Ibericam or another provider.',
          isActive: 'Active',
          status: 'Status',
          confirmDelete: 'Delete this web camera?',
        },
        company: {
          legalName: 'Legal name',
          tradeName: 'Trade name',
          taxId: 'Tax ID',
          address: 'Address',
          city: 'City',
          postalCode: 'Postal code',
          province: 'Province',
          country: 'Country (ISO)',
          phone: 'Phone',
          email: 'Billing email',
          website: 'Website',
          timezone: 'Timezone',
          locale: 'Locale',
          currency: 'Currency',
          vat: 'Default VAT (%)',
          footer: 'Invoice footer',
        },
        verifactu: {
          enabled: 'Verifactu enabled',
          status: 'Status',
          environment: 'Environment',
          nif: 'Issuer NIF',
          razon: 'Legal name',
          softwareNif: 'Software NIF',
          softwareName: 'Software name',
          softwareId: 'Software ID',
          softwareVersion: 'Software version',
          apiUrl: 'AEAT URL',
          certificate: 'PEM certificate',
          certificateHint: 'Paste certificate (stored encrypted). Leave empty to keep current.',
          passphrase: 'Certificate passphrase',
          validate: 'Validate setup',
          validated: 'Verifactu validated and ready',
          hasCert: 'Certificate loaded',
          noCert: 'No certificate',
        },
        openai: {
          enabled: 'OpenAI enabled',
          apiKey: 'API key',
          apiKeyPlaceholder: 'sk-…',
          apiKeyKeep: '•••••••• (leave blank to keep)',
          apiKeyHint: 'Stored encrypted. Leave blank to keep the current key.',
          hasKey: 'API key configured',
          noKey: 'No API key',
          organizationId: 'Organization ID',
          projectId: 'Project ID',
          baseUrl: 'Base URL',
          defaultModel: 'Default model',
          temperature: 'Temperature',
          maxTokens: 'Max tokens',
          models: {
            'gpt-4o-mini': 'gpt-4o-mini (ideal for image recognition)',
            'gpt-4o': 'gpt-4o (ideal for advanced multimodal vision)',
            'gpt-4.1-mini': 'gpt-4.1-mini (ideal for fast, low-cost text)',
            'gpt-4.1': 'gpt-4.1 (ideal for long-form precision)',
            'o4-mini': 'o4-mini (ideal for complex reasoning)',
            'o3-mini': 'o3-mini (ideal for logic and planning)',
            'gpt-4o-mini-tts': 'gpt-4o-mini-tts (ideal for speech synthesis)',
            'text-embedding-3-small': 'text-embedding-3-small (ideal for semantic search)',
            'whisper-1': 'whisper-1 (ideal for audio transcription)',
          },
        },
        push: {
          enabled: 'Push / webhooks enabled',
          notifyOpen: 'Entries',
          notifyClose: 'Exits',
          notifyInvoice: 'Invoices',
          notifyPayment: 'Payments',
          notifyIncident: 'Incidents',
          webhookUrl: 'Webhook URL',
          webhookSecret: 'Webhook secret',
          subscribe: 'Enable on this device',
          test: 'Send test',
          devices: 'Devices',
          logs: 'Delivery log',
          label: 'Device',
          created: 'Created',
          channel: 'Channel',
          titleCol: 'Message',
          status: 'Status',
          noVapid: 'VAPID not configured on platform',
          unsupported: 'This browser does not support Web Push',
          denied: 'Notification permission denied',
          subscribeFailed: 'Could not subscribe to push',
          subscribed: 'Device registered',
          testResult: 'Test sent: {{sent}} ok, {{failed}} failed',
        },
      },
      platform: {
        brand: 'Parking Platform',
        login: {
          subtitle: 'SaaS platform super-admin access',
          email: 'Email',
          password: 'Password',
          submit: 'Sign in',
          tenantLogin: 'Tenant login',
        },
        nav: {
          dashboard: 'Dashboard',
          tenants: 'Tenants',
          settings: 'Platform',
        },
        dashboard: {
          title: 'Platform dashboard',
          subtitle: 'Global view across all tenants',
          tenants: 'Tenants',
          active: 'Active',
          users: 'Users',
          openSessions: 'Open sessions',
          recent: 'Recent tenants',
        },
        tenants: {
          title: 'Tenants',
          subtitle: 'Provision, suspend and first admin',
          create: 'New tenant',
          edit: 'Edit tenant',
          slug: 'Slug',
          slugHint: 'lowercase-kebab-case',
          name: 'Name',
          status: 'Status',
          users: 'Users',
          parkings: 'Parkings',
          sessions: 'Sessions',
          adminSection: 'Initial admin (optional)',
          adminEmail: 'Admin email',
          adminPassword: 'Admin password',
          adminFirstName: 'First name',
          adminLastName: 'Last name',
        },
        settings: {
          title: 'Platform settings',
          subtitle: 'VAPID Web Push and super-admins',
          push: 'Web Push (VAPID)',
          supportEmail: 'Support email',
          vapidSubject: 'VAPID subject',
          vapidSubjectHint: 'mailto:…',
          vapidPublic: 'VAPID public key',
          regenVapid: 'Regenerate VAPID',
          confirmRegen: 'Regenerate VAPID keys? Devices must re-subscribe.',
          vapidRegenerated: 'VAPID keys regenerated',
          saved: 'Settings saved',
          admins: 'Super-admins',
          createAdmin: 'New super-admin',
          adminName: 'Name',
        },
      },
    },
  },
};

void i18n.use(initReactI18next).init({
  resources,
  lng: 'es',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
